/**
 * Formats a date string into a human-readable format
 * @param {string|Date|null} date - The date to format
 * @returns {string} Formatted date string or "No activity launches" if invalid
 */
export const formatDate = (date) => {
  if (hasNoActivityLaunchDate(date)) {
    return 'No activity launches';
  }

  const dateObj = new Date(date);

  const formattedTime = dateObj
    .toLocaleString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
    .toLowerCase()
    .replace(' ', '');

  const formattedDate = dateObj.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return `${formattedDate} ${formattedTime}`;
};

export const hasNoActivityLaunchDate = (date) =>
  !date || isNaN(new Date(date).getTime());

export const getUserTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
